import { Dialog, TextField } from "@mui/material";
import { useState } from "react";
import DialogContentSelectGeneric from "../DialogsContents/DialogContentGeneric";
import { defValuePerfil, IPesquisaPerfis } from "../../../types/api/geral/pesquisar-perfis";

export default function SelectPerfil({
    value,
    required = false,
    error = false,
    errorMessage = undefined,
    possuiBtnLimpar = false,
    onChange,
    disabled = false
}: SelectSimpleApiQueryProps) {

    const [openModal, setOpenModal] = useState(false);

    const handleClose = () => setOpenModal(false);

    const inputLabel = value ? `${value.nome}` : "";

    return (
        <>
            <TextField
                {...{ required, error }}
                label={`Perfil`}
                variant="outlined"
                fullWidth
                onClick={() => !disabled && setOpenModal(true)}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        setOpenModal(true);
                    }
                }}
                disabled={disabled}
                slotProps={{
                    input: { readOnly: true }
                }}
                value={inputLabel}
                helperText={error ? errorMessage : ""}
            />

            {
                openModal &&
                <Dialog
                    fullWidth
                    maxWidth="sm"
                    open={openModal}
                    onClose={handleClose}
                >
                    <DialogContentSelectGeneric
                        {...{ handleClose, possuiBtnLimpar }}
                        title="Selecionar perfil"
                        queryPath="/pesquisar-perfis"
                        getItemKey={(item) => item.id}
                        getItemLabel={(item) => `${item.nome}`}
                        defaultValue={value || defValuePerfil}
                        onChange={(value) => {
                            onChange(value as IPesquisaPerfis);
                            handleClose();
                        }}
                    />
                </Dialog>
            }
        </>
    );
}

interface SelectSimpleApiQueryProps {
    value: IPesquisaPerfis | null | undefined;
    onChange: (arg: IPesquisaPerfis | null) => void;
    required?: boolean;
    error?: boolean;
    errorMessage?: string | undefined;
    possuiBtnLimpar?: boolean;
    disabled?: boolean;
}